<!--TEMPLATE-->

<template>
        <div :class="landingPageClass">
            <div class="row">
                <div class="small-12 medium-12 large-12 hd-12 columns">
                    <dean-section-title content='true'>
                        <span slot='title'>
                            <span class='avenir-heavy'>Stamgegevens</span>
                        </span>
                    </dean-section-title>
                </div>
            </div>
            <div id="standingDataItems">
                <div class="standingDataItem"
                        v-for="standingDataItem in standingDataItems.items"
                        @click="routeToItem(standingDataItem.name)">
                    <dean-icon class="standingDataItemIcon" :glyph="standingDataItem.icon">
                    </dean-icon>
                    <p>{{standingDataItem.title}}</p>
                </div>
            </div>
        </div>
</template>

<!--SCRIPT-->
<script lang="ts">
    import {Vue, Component} from 'vue-property-decorator';

    import {
        // COMPONENTS
        deanSectionTitle,
        deanIcon,
        // ICONS
        addItemIcon,
        usersIcon,
        invoiceIcon,
        partnerIcon,
        commissionIcon,
        calendarTimeIcon,
        warningIcon,
    } from '@deanone/dean-components';

    @Component({
        components: {
            deanSectionTitle,
            deanIcon,
        },
    })

    export default class LandingPage extends Vue {
        public standingDataItems = {
            title: 'Stamgegevens',
            items: {
                products: {
                    title: 'Producten',
                    icon: addItemIcon,
                    name: 'standingData.products',
                },
                provisioningServices: {
                  title: 'Diensten',
                  icon: addItemIcon,
                  name: 'standingData.provisioningServices',
                },
                groups: {
                    title: 'Groepen',
                    icon: usersIcon,
                    name: '',
                },
                pricePlans: {
                    title: 'Prijsplannen',
                    icon: invoiceIcon,
                    name: 'standingData.pricePlans',
                },
                recurringCommissionPlans: {
                    title: 'Periodieke Commissieplannen',
                    icon: commissionIcon,
                    name: 'standingData.recurringCommissionPlans',
                },
                partnerTypes: {
                    title: 'Partner Types',
                    icon: partnerIcon,
                    name: 'standingData.partnerTypes',
                },
                productTerms: {
                    title: 'Product termijnen',
                    icon: calendarTimeIcon,
                    name: 'standingData.productTerms',
                },
            },
        };

        public created() {
            this.$store.dispatch('updateSideMenu', {});
        }

        // COMPUTED
        get landingPageClass() {
            return 'landing-page-content';
        }

        public routeToItem(name: string) {
            this.$router.push({name});
        }

    }
</script>

<!--STYLE-->

<style lang="scss" scoped>
    @import '~@deanone/dean-components/src/scss/vars';

    #standingDataItems {
        padding: 0 10px 10px 10px;
        display: grid;
        min-height: calc(100vh - (80px + 70px));
        grid-template-columns: calc(100%/3 - 2%) calc(100%/3 - 2%) calc(100%/3 - 2%);
        grid-template-rows: calc(100%/3 - 2%) calc(100%/3 - 2%) calc(100%/3 - 2%);
        grid-column-gap: 3%;
        grid-row-gap: 3%;
    }

    .standingDataItem {
        height: 100%;
        box-shadow: 0 0 0.38rem rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        transition: box-shadow 0.2s;
        padding: 5px;
        position: relative;

        p {
            color: var(--color-dark-shade-4, $color-dark-shade-4);
            min-width:0;
            flex-basis: auto;
            text-align:center;
            font-size: $font-large;
            text-transform: uppercase;
            font-style: italic;
            @include transition(all ease 0.2s);
        }

        &:hover {
            box-shadow: 0 0 0.38rem var(--color-primary, $color-primary);
            cursor: pointer;

            p {
                color: var(--color-primary, $color-primary);
            }

            .standingDataItemIcon {
                fill: var(--color-primary, $color-primary);
            }
        }
    }

    .standingDataItemIcon {
        height: 30px;
        width: 30px;
        fill: var(--color-dark-shade-4, $color-dark-shade-4);;
        @include transition(all ease 0.2s);
    }

    @media #{$small-down} {
        #standingDataItems {
            grid-template-columns: calc(100%/2 - 2%) calc(100%/2 - 2%);
            grid-template-rows: calc(100%/2 - 2%) calc(100%/2 - 2%);
        }
    }

    @media #{$medium} {
        .standingDataItemIcon {
            height: 60px;
            width: 60px;
        }
        .standingDataItem {
            p {
                font-size: calc(#{$font-large} * 2);
            }
        }
    }


</style>
